import * as types from './articleActionTypes';
import firebaseApp from './../../utils/firebase/firebase';
import {push} from 'react-router-redux';

import SingletonLibrary from '../../library/SingletonLibrary';

import fakeData from '../../assets/data/fakeArticle.json';

export const showComment = () => {
    return {
        type: types.SHOW_COMMENT
    }
}

export const hideComment = () => {
    return {
        type: types.HIDE_COMMENT
    }
}

export const showBlockedCommentPopup = () => {
    return {
        type: types.SHOW_BLOCKED_COMMENT_POPUP
    }
}

export const hideBlockedCommentPopup = () => {
    return {
        type: types.HIDE_BLOCKED_COMMENT_POPUP
    }
}

export const addEmoReactionStart = () => {
    return {
        type: types.EMO_REACTION_START
    }
}

export const addEmoReactionSuccess = (payload, reactionId) => {
    //the payload is used by the action logger
    return {
        type: types.EMO_REACTION_SUCCESS, payload, reactionId
    }
}

export const addEmoReactionFail = () => {
    return {
        type: types.EMO_REACTION_FAIL
    }
}

export function addEmoReaction(articleInfo, username, reactionId) {
    return (dispatch, getState) => {
        dispatch(addEmoReactionStart());
        const userID = firebaseApp.auth().currentUser.uid;
        const articleId = articleInfo.id;
        const thematicSlug = articleInfo.thematic;
        const editionSlug = articleInfo.edition;

        firebaseApp
            .database()
            .ref(`articles-reactions/${articleId}`)
            .once('value')
            .then((snapshot) => {
                //-- If an article doesn't exist, we create it
                if (snapshot.val() === null) {
                    return firebaseApp
                        .database()
                        .ref(`articles-reactions/${articleId}/`)
                        .set({
                            thematicSlug, editionSlug, reactions: {
                                [userID]: {
                                    username, reactionId, createdAt: new Date().getTime()
                                }
                            }
                        });
                } else {//-- Also, if an article match, we push a reaction
                    return firebaseApp
                        .database()
                        .ref(`articles-reactions/${articleId}/reactions/${userID}`)
                        .set({
                            username, reactionId, createdAt: new Date().getTime()
                        });
                }
            })
            .then(() => {
                //the payload is used by the action logger
                var payload = {
                    action: 'react',
                    entityId: articleId,
                    entityValue: getState().article.currentArticle.title,
                    value: reactionId,
                    point: false
                };
                dispatch(addEmoReactionSuccess(payload, reactionId));

                // force to refresh article's reaction mapping 
                dispatch(getAllArticleReactionsByEdition(editionSlug));

            })
            .catch((error) => {
                dispatch(addEmoReactionFail(error.message, error.code));
            });
    }
}

export const getAllArticleReactionsStart = () => {
    return {
        type: types.RETRIEVE_ARTICLE_REACTIONS_START
    }
}

export const getAllArticleReactionsSuccess = (totalReactions) => {
    return {
        type: types.RETRIEVE_ARTICLE_REACTIONS_SUCCESS, totalReactions: totalReactions
    }
}

export const getAllArticleReactionsFail = () => {
    return {
        type: types.RETRIEVE_ARTICLE_REACTIONS_FAIL
    }
}

const getAllArticleReactionsByType = (type, slug) => {
    return (dispatch, getState) => {
        dispatch(getAllArticleReactionsStart());

        // add user reaction related to the corresponding article
        firebaseApp.database()
            .ref(`articles-reactions`)
            .orderByChild(type) //-- index type inside Firebase
            .equalTo(slug) //-- slug 
            .once('value')
            .then((snapshot) => {
                const datas = snapshot.val();
                const reactionsByArticle = [];
                if (datas !== null) {


                    for (let articleId in datas) {
                        const totalReactions = Object.keys(datas[articleId].reactions).length;
                        reactionsByArticle.push({articleId, totalReactions});
                    }
                }

                dispatch(getAllArticleReactionsSuccess(reactionsByArticle));

            })
            .catch((error) => {
                dispatch(getAllArticleReactionsFail(error.message, error.code));
            });
    }
}

export const getAllArticleReactionsByEdition = (editionSlug) => {
    const type = "editionSlug";
    return (dispatch) => {
        dispatch(getAllArticleReactionsByType(type, editionSlug));
    }

}

export const getAllArticleReactionsByThematic = (thematicSlug) => {
    const type = "thematicSlug";
    return (dispatch) => {
        dispatch(getAllArticleReactionsByType(type, thematicSlug));
    }

}

export const getArticleContentStart = () => {
    return {
        type: types.RETRIEVE_ARTICLE_CONTENT_START
    }
}

export const getArticleContentSuccess = (articleContent, payload) => {
    //Payload is used by the action logger
    return {
        type: types.RETRIEVE_ARTICLE_CONTENT_SUCCESS, articleContent: articleContent, payload
    }
}

export const getFakeArticleContentSuccess = (articleContent) => {
    return {
        type: types.RETRIEVE_FAKE_ARTICLE_CONTENT_SUCCESS, articleContent: articleContent
    }
}

export const getArticleContentFail = () => {
    return {
        type: types.RETRIEVE_ARTICLE_CONTENT_FAIL
    }
}

export function getArticleContent(articleId, redirect = true) {
    return (dispatch, getState) => {

        if (getState().article.articleRetrievalInProgress) {
            return;
        }

        dispatch(getArticleContentStart());

        if (firebaseApp.auth().currentUser !== null) {
            firebaseApp.auth().currentUser.getIdToken()
                .then((fbIdToken) => {
                    return SingletonLibrary
                        .getAxiosInstance
                        .get('/article/' + articleId, {headers: {'fbkm-access-token': fbIdToken}})
                })
                .then((result) => {
                    const response = (result.error !== true && typeof result.data.response !== 'undefined') ? result.data.response : null;

                    if (response !== null) {
                        if (typeof response._source !== 'undefined') {
                            const articleTitle = response._source.title;
                            //the payload is used by the action logger
                            var payload = {
                                action: 'read', entityId: articleId, entityValue: articleTitle, value: '', point: false
                            };

                            dispatch(getArticleContentSuccess(response._source, payload));

                            // redirect to article details page
                            if (redirect) {
                                const articleTitleclean = articleTitle.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                                    .replace(/(^\-+|[^a-zA-Z0-9\/_| -\!]+|\-+$)/g, '')
                                    .toLowerCase()
                                    .replace(/[\/_| -]+/g, '-');
                                const articleURL = '/article/' + articleTitleclean + '-' + response._source.id;
                                dispatch(push(articleURL));
                            }
                        }
                    }
                })
                .catch((e) => {
                    const errorCode = (typeof e.response !== 'undefined' && e.response.status) || 0;
                    const errorMessage = (typeof e.response !== 'undefined' && e.response.statusText) || 'Erreur inattendue';

                    dispatch(getArticleContentFail(errorMessage, errorCode));
                });
        } else {
            dispatch(getFakeArticleContent(articleId));
        }
    }

}

export const getFakeArticleContent = (articleId) => {
    return (dispatch, getState) => {

        fakeData.id = articleId;

        if( Object.keys(getState().editions.current).length > 0 ) {
            const currentEdition = getState().editions.current.edition_management;

            let article;
            for (let i = 0; i < currentEdition.length; i++) {
                for (let j = 0; j < currentEdition[i].length; j++) {
                    article = currentEdition[i][j];
                    if (article.id === articleId) {

                        fakeData.title = article.title;
                        fakeData.kids_thematic = article.thematic;
                        fakeData.blocks[1] = article.main_block;
                        fakeData.document_type = article.document_type;
                        fakeData.uri = article.slug;
                    }
                }
            }

        }

        dispatch(getFakeArticleContentSuccess(fakeData));

        const articleURL = '/discover/article/' + fakeData.uri + '-' + articleId;
        dispatch(push(articleURL));
    }
}

export const getArticleEmoReactionStart = () => {
    return {
        type: types.RETRIEVE_ARTICLE_EMO_REACTION_START
    }
}

export const getArticleEmoReactionSuccess = (reactionId) => {
    return {
        type: types.RETRIEVE_ARTICLE_EMO_REACTION_SUCCESS, userArticleReaction: reactionId
    }
}

export const getArticleEmoReactionFail = () => {
    return {
        type: types.RETRIEVE_ARTICLE_EMO_REACTION_FAIL
    }
}

export const getArticleEmoReaction = (articleId) => {
    return (dispatch) => {
        dispatch(getArticleEmoReactionStart());

        const userID = firebaseApp.auth().currentUser.uid;

        // look for the user's reaction related to the corresponding article
        firebaseApp.database()
            .ref(`articles-reactions/${articleId}/reactions/${userID}`)
            .once('value')
            .then((snapshot) => {
                const datas = snapshot.val();
                let userReactionId = 0;
                if (datas !== null) {
                    userReactionId = parseInt(datas.reactionId, 10);
                }

                dispatch(getArticleEmoReactionSuccess(userReactionId));

            })
            .catch((error) => {
                dispatch(getArticleEmoReactionFail(error.message, error.code));
            });
    }
}


// WEBPACK FOOTER //
// ./src/components/Article/articleActions.js